module.exports = __webpack_public_path__ + "img/produit_9.fb5c6490.png";